/*
 * Created by: cparaschiv
 * Date: 22.04.2014, 11:04 
 */

(function ($) {
    'use strict';

    var ui = kendo.ui,
        Grid = ui.Grid,
        DATA_CELL = ":not(.k-group-cell):not(.k-hierarchy-cell):visible",
        CHANGE = "change",
        CLICK = 'click',
        NS = '.tsKendoGrid',
        NAVROW = "tr:not(.k-footer-template):visible",
        NAVCELL = ":not(.k-group-cell):not(.k-hierarchy-cell):visible",
        unwrap = TS.unwrap,
        SUBSCRIPTION_MARKER = 'tsKendoGrid',
        uneditableColumns = ['radio', 'bool', 'hyperlink', 'radiogroup'];

    function isMonitored(model, column) {
        var propName = column.fieldCfg.PropertyName(),
            obs, subs,
            ret = false;

        obs = model[propName];
        if (TS.isObservable(obs)) {
            subs = obs._subscriptions && obs._subscriptions['change'];
            $.each(subs, function (idx, sub) {
                if (sub._marker == SUBSCRIPTION_MARKER) {
                    ret = true;
                    return false;
                }
            });
        }

        return ret;
    }

    function _handleCheckEdit(grid, model, column, cell) {

        try {
            var fld = column.field,
                val = unwrap(model[fld]);

            grid._fakeEditable = true;
            model[fld](!val);
            grid._displayCell(cell, column, model);
            _toggleCheckEditClass(grid, cell, false);
        } finally {
            grid._fakeEditable = false;
        }
    }

    function _toggleCheckEditClass(grid, current, focused) {

        var column = grid.columns[grid.cellIndex(current)];
        if (column.type == 'bool') {
            var image = current.find('i');
            var model = grid._modelForContainer(current);
            var val = unwrap(model[column.field]);

            var iconCheckedClass = 'fa fa-check-square',
                iconUncheckedClass = 'fa fa-square';

            if (image !== undefined) {
                if (focused === true) {
                    if (val === false) {
                        image.removeClass(iconUncheckedClass + '-o').addClass(iconUncheckedClass);
                    } else {
                        image.removeClass(iconCheckedClass + '-o').addClass(iconCheckedClass);
                    }
                } else {
                    if (val === false) {
                        image.removeClass(iconUncheckedClass).addClass(iconUncheckedClass + '-o');
                    } else {
                        image.removeClass(iconCheckedClass).addClass(iconCheckedClass + '-o');
                    }
                }
            }
        }
    }

    function _handleRadioCell(grid, model, column, cell, e) {
        var me = grid,
            strVal, val, column, model, uid, rowIdx;

        if(e === undefined)
            return;

        strVal = $(e.target).val();
        val = parseInt(strVal, 10);

        column = me.columns[me.cellIndex(cell)];
        model = me._modelForContainer(cell);

        // when the user clicks the label, this handler returns; then editCell is called, which observes the record
        // so the next time this handler is called (for the INPUT tag), the model is monitored and cellValueChanged is raised
        // when the user clicks the input, the model is not being observed
        // so check here if that's the case and call _observeRecord
        if (e.target.tagName == 'INPUT' && !isMonitored(model, column)) {
            uid = me._uidForContainer(cell);
            rowIdx = me.dataSource.indexFor(uid);
            me._observeRecord(model, column, rowIdx);
        }

        // set value in record
        model[column.field](val);

        // refresh cell
        me._displayCell(cell, column, model);
    }

    // copy some config values from field
    function _getListFieldConfig(fld) {
        var cfg = {},
            props = ['Name', 'PropertyName', 'DisplayPropertyName', 'MaxLength', 'IsDynamicColumn', 'EditorNameProperty',
                'format', 'decimalPrecision', 'useThousandSeparator',

                'propertyPath',
                'browseProperty', 'listTextProperty', 'listValueProperty', 'textProperty', 'valueProperty', 'browseUrl',
                'allowInput'
            ];

        /*Object.defineProperty(cfg, 'listField', {
         enumerable: false,
         //writable: false,
         get: function () {
         return fld;
         }
         });*/
        cfg.listField = fld;
        $.each(props, function (i, prop) {
            if (TS.isDefined(fld[prop])) {
                cfg[prop] = fld[prop];
            }
        });

        return cfg;
    }

    function _showTooltip(container, text) {

        var tooltip = container.kendoTooltip({
            autoHide: false,
            showOn: "click",
            position: "top",
            width: 200,
            //height: 100,
            content: text,
            animation: {
                open: {
                    duration: "200"
                },
                close: {
                    duration: "200"
                }
            }
        }).data("kendoTooltip");

        tooltip.show();

        return tooltip;
    }

    var TsKendoGrid = Grid.extend({

        _bindingListProperty: null,
        _transports: {},
        _alternateRowStyle: false,

        _prevUID: null,         // previously selected UID, used to instruct BLP to update selected item; updated only on changes
        _prevSelection: false,  // previously selected UID, used to restore selection after grid redraw; always updated

        _modelSubscriptions: [],

        _tooltip: null,
        _fakeEditable: false,

        options: {
            name: "TsKendoGrid"
        },

        init: function (element, options) {
            var me = this,
                blp;

            options.columnResizeHandleWidth = 6;
            me._transports = {};

            if (arguments.length === 3 && me._bindingListProperty) {
                blp = me._bindingListProperty;
                options.dataSource = me.dataSource = me._buildKoDs(blp);
            } else {
                blp = options.dataSource;
                options.dataSource = me._setBlp(blp);
            }

            if (TS.isDefined(blp.PageSize) && TS.isNumber(blp.PageSize)) {
                options.pageable = {
                    pageSize: blp.PageSize,
                    messages: TS.cultures.current.pagerMessages,
                    buttonCount: 5,
                    info: false
                };
            }

            me.setOrCreateObservable('AllowAdd', options.allowAdd);
            me.setOrCreateObservable('AllowEdit', options.allowEdit);
            me.setOrCreateObservable('AllowDelete', options.allowDelete);
            me.setOrCreateObservable('ReadOnly', options.readOnly);
            me.setOrCreateObservable('ShowColumnHeaders', options.showColumnHeaders);

            options.columns = me._buildColumns(blp, options);
            options.toolbar = me._buildToolbar(blp);


            blp.customiseOptions && blp.customiseOptions(options);
            Grid.fn.init.call(this, element, options);

            me.element.delegate("tbody>tr", "dblclick", $.proxy(me._onDblClick, me));
        },

        getOptions: function () {
            //hide listField
            var me = this;
            if (!me.columns.__hiddenListFields__) {
                $.each(me.columns, function (index, column) {
                    var fieldCfg = column.fieldCfg,
                        listField = fieldCfg.listField;
                    delete fieldCfg.listField;
                    Object.defineProperty(fieldCfg, 'listField', {
                        enumerable: false,
                        configurable: false,
                        get: function () {
                            return listField;
                        }
                    });
                });
                me.columns.__hiddenListFields__ = true;
            }
            return Grid.fn.getOptions.apply(this, arguments);
        },

        setOptions: function () {
            var me = this;
            Grid.fn.setOptions.apply(this, arguments);
            ko.applyBindingsToDescendants(me._bindingListProperty && me._bindingListProperty._getOwner(), me.element[0]);
        },

        setOrCreateObservable: function (name, value) {
            var me = this;
            if (!me[name]) {
                me[name] = ko.observable(value);
            }
            me[name](value);
        },

        _buildColumns: function (blp, options) {
            var me = this,
                fields = blp.Fields(),
                cols = [];

            $.each(fields, function (key, f) {
                var colCfg, fieldCfg;

                colCfg = me._buildColumn(f, options);
                if (colCfg) {
                    cols.push(colCfg);
                    fieldCfg = colCfg.fieldCfg;
                    if (fieldCfg.IsDynamicColumn) {
                        colCfg.template = TS.UI.CellRenderer.getKendoCellTemplate(fieldCfg);
                    }
                }
            });
            return cols;
        },

        _buildColumn: function (f, options) {
            var me = this,
                isHidden,
                fieldName,
                headerAttr = null,
                headerClass,
                colCfg,
                format,
                editable = options.editable;
            
            //editable --> property of parent grid
            //f.ReadOnly --> property of grid's field

            if (!editable) {
                f.controlIsEditable = false;
                f.readOnly = true;
            }
            else {
                if (f.ReadOnly) {
                    f.readOnly = true;
                }
            }

            isHidden = !!f.hidden || f.Visible() === false;

            fieldName = ko.valueOf(f.DisplayPropertyName) || f.PropertyName();

            // skip hidden & dynamic fields
            if (f.IsDynamicEditor || isHidden === true || fieldName == "editLink") {
                return null;
            }

            format = f.format;
            if (f.type == 'numeric') {
                format = TS.Util.kendoNumericFormat(f.decimalPrecision, f.useThousandSeparator);
            }

            headerClass = TS.UI.Renderers.grid._default.getHeaderClass(f);

            if (headerClass) {
                headerAttr = {
                    "class": headerClass
                }
            }

            if (!me.ShowColumnHeaders()) {
                headerAttr = headerAttr || {};
                headerAttr["style"] = 'display: none';
            }

            colCfg = {
                field: fieldName,
                title: f.Title() || "",
                format: format,
                hidden: isHidden,
                locked: !!f.Frozen(),
                resizable: f.AllowResize,
                sortable: f.AllowSort(),
                editable: TS.isDefined(f.ReadOnly) ? !f.ReadOnly : true,
                type: f.type,
                headerAttributes: headerAttr,
                fieldCfg: _getListFieldConfig(f),
                autopOpen: f.AutoOpen || false,
                template: TS.UI.CellRenderer.getKendoCellTemplate(f)
            };


            options.columnAutoWidth === false && f.Width && (colCfg.width = f.Width);

            return colCfg;
        },

        _buildCommand: function (cmd, blp) {
            var me = this,
                cfg,
                code = unwrap(cmd.Code),
                text = unwrap(cmd.Text),
                cls = 'ts-cmd-' + code,
                id = blp.Name + '.' + code;

            //corect path for properties in subDomains
            var domain = blp.Domain();
            if (domain && domain.subdomainPath)
                id = domain.subdomainPath + '.' + id;


            switch (code) {
                case 'Add':
                    if (!cmd.__InternalEnabled__) {
                        cmd.__InternalEnabled__ = cmd.InternalEnabled;
                    }
                    cmd.InternalEnabled = ko.computed(function () {
                        return cmd.__InternalEnabled__() && me.AllowAdd() && me.ReadOnly() !== true;
                    });

                    if (!cmd.__InternalVisible__) {
                        cmd.__InternalVisible__ = cmd.InternalVisible;
                    }
                    cmd.InternalVisible = ko.computed(function () {
                        return cmd.__InternalVisible__() && me.AllowAdd() && me.ReadOnly() !== true;
                    });
                    break;
                case 'Delete':
                    if (!cmd.__InternalEnabled__) {
                        cmd.__InternalEnabled__ = cmd.InternalEnabled;
                    }
                    cmd.InternalEnabled = ko.computed(function () {
                        return cmd.__InternalEnabled__() && me.AllowDelete() && me.ReadOnly() !== true;
                    });

                    if (!cmd.__InternalVisible__) {
                        cmd.__InternalVisible__ = cmd.InternalVisible;
                    }
                    cmd.InternalVisible = ko.computed(function () {
                        return cmd.__InternalVisible__() && me.AllowDelete() && me.ReadOnly() !== true;
                    });
                    break;
            }

            cfg = {
                name: code,
                text: text,
                className: cls,
                iconClass: unwrap(cmd.IconCode),
                template: [
                    '<a class="ts-grid-command" id="' + id + '" name="' + id + '" type="hyperlink" data-bind="cmd: \'' + id + '\'">' + text,
                    '</a>'].join('')
            };

            return cfg;
        },


        _buildToolbar: function (blp) {
            var me = this,
                tb = [];

            $.each(blp.Commands(), function (i, cmd) {
                var cmdCfg;

                cmdCfg = me._buildCommand(cmd, blp);
                cmdCfg && tb.push(cmdCfg);
            });

            return tb;
        },

        _setBlp: function (blp) {
            var me = this,
                koDs, opts;

            if (!blp) {
                return;
            }

            blp.un('dataChanged', me._onDataChanged);
            blp.on('dataChanged', me._onDataChanged, me);

            blp.on('selectedItemChanged', me._onSelectedItemChanged, me);
            blp.on('filterChanged', me._onFilterChanged, me);

            blp.on('invalidate', me._onInvalidate, me);


            koDs = me._buildKoDs(blp);

            me._bindingListProperty = blp;
            me.dataSource = koDs;

            return koDs;
        },

        _buildKoDs: function (blp) {
            var koDs, opts;

            opts = {
                localData: blp.ListSource()
            };

            if (TS.isNumber(blp.PageSize)) {
                opts.pageSize = blp.PageSize;
            }

            koDs = new TS.data.KoGridSource(opts);

            return koDs;
        },

        _onDataChanged: function (e) {
            var me = this,
                blp;

            blp = e.sender;

            me.dataSource.data(blp.ListSource());
            me.refresh();
        },

        _onSelectedItemChanged: function (e) {
            var me = this,
                blp,
                selectedItem;

            blp = e.sender;
            selectedItem = blp.SelectedItem();
            if (selectedItem) {
                var selectedItemUid = TS.unwrap(selectedItem.UID);

                if (selectedItemUid != me._prevSelection) {
                    me._prevSelection = selectedItemUid;
                    me._doRestoreSelection();
                    if (me.options.autoFocus && me.options.editable) {
                        var cellToEdit = me.select().find("td:eq(0)"),
                            navigatable = me.options.navigatable;
                        if (cellToEdit.length) {
                            cellToEdit = $(cellToEdit[0]);//ensure only one cell to edit, for grids with fixed columns length = 2
                            navigatable && me.current(cellToEdit);
                            me.editCell(cellToEdit, true);
                            if (!me.editable && navigatable) {
                                var table = me.table.add(me.lockedTable),
                                    e = $.Event("keydown", {keyCode: 9});
                                // trigger an artificial tab
                                table.trigger(e);
                            }
                        }
                    }
                }
            }
        },

        _onFilterChanged: function (e) {
            var me = this,
                blp;

            blp = e.sender;

            me.dataSource.filter(blp.Filters);
            me.refresh();
        },

        _onInvalidate: function (e) {
            var me = this,
                options = $.extend({}, me.getOptions());
            me.setOptions(options);
        },

        _wrapper: function () {
            var me = this,
                scrollable = me.options.scrollable,
                height = me.options.height;

            Grid.fn._wrapper.call(me);
            me.wrapper.addClass('ts-grid-edit');
            if (height && scrollable) {
                me.wrapper.addClass('ts-grid-edit-scrollable');
            }
        },

        _attachModelChange: $.noop,
        _detachModelChange: $.noop,

        _observeRecord: function (model, column, rowIdx) {
            var me = this,
                propName = column.fieldCfg.PropertyName(),
                obs,
                currentVal,
                sub;

            obs = model[propName];

            if (TS.isObservable(obs)) {
                me._modelSubscriptions.length && me._disposeSubcriptions();
                currentVal = unwrap(obs);
                sub = obs.subscribe(function (newVal) {
                    me._onModelChanged(rowIdx, model, currentVal, newVal, column);
                    currentVal = newVal;
                });
                sub._marker = SUBSCRIPTION_MARKER;
                me._modelSubscriptions.push(sub);
                return sub;
            }
        },

        _disposeSubcriptions: function () {
            var me = this;

            $.each(me._modelSubscriptions, function (idx, sub) {
                sub && sub.dispose();
            });

            me._modelSubscriptions = [];
        },

        _onDblClick: function () {
            var me = this,
                bindingListProperty = me._bindingListProperty;

            if (bindingListProperty.executeDefault) {
                bindingListProperty.executeDefault();
            }
        },

        _onModelChanged: function (rowIdx, model, oldValue, newValue, column) {
            var me = this,
                e = me._buildEventArgs(rowIdx, model, oldValue, newValue, column);

            if (oldValue != newValue) {
                me._bindingListProperty._onCellValueChanged(e);
                me._refreshCurrentRow(column);
            }
        },

        refresh: function (e) {
            var me = this;

            if (!me._fakeEditable)
                Grid.fn.refresh.call(this, e);

            // restore selection after edit (by default the Kendo grid doesn't)
            me._doRestoreSelection();
        },

        _renderContent: function (data, colspan, groups) {
            var me = this,
                emptyContent;

            Grid.fn._renderContent.call(this, data, colspan, groups);

            emptyContent = $('.grid-empty-content', me.content);
            if (me.tbody.html() == '') {
                if (!emptyContent.length)
                    me.content.append(TS.UI.Renderers.list._default.getEmptyContent());
            } else {
                if (emptyContent.length)
                    emptyContent.remove();
            }
        },

        _doRestoreSelection: function () {
            var me = this,
                el;

            if (me._prevSelection) {
                el = $(me.table).find('[data-uid="' + me._prevSelection + '"]').first();
                if (el.length) {
                    me.clearSelection();
                    me.select(el);
                    //me.selectable.value(el);
                }
            }
        },

        _selectable: function () {
            var me = this;

            Grid.fn._selectable.call(me);

            me.selectable.bind(CHANGE, $.proxy(me._onSelectionChanged, me));
        },

        _onSelectionChanged: function (e) {
            var me = this,
                selection, uid;

            selection = me.selectable.value();
            uid = selection && $(selection).attr('data-uid');
            if (me._bindingListProperty && me._bindingListProperty.hideSelection === true)
                $(selection).removeClass("k-state-selected");
            me._prevSelection = uid;

            if (uid != me._prevUID) {
                me._disposeSubcriptions();
                me._prevUID = uid;
                me._bindingListProperty.SelectedItemId(uid);
            }
        },

        _uidForContainer: function (container) {
            var id;

            container = $(container);

            if (!container.is("tr") && this._editMode() !== "popup") {
                container = container.closest("tr");
            }

            id = container.attr(kendo.attr("uid"));

            return id;
        },

        _onRadioCellClicked: function (e) {
            var me = this,
                cell, result;

            // clicking the label triggers the event twice: once for the label and second for the radio input
            // don't do anything for the label, handler will be called once again for the radio input
            if (e.target.tagName == 'LABEL' || e.target.tagName != 'INPUT') {
                return;
            }

            cell = $(e.target).closest('td');
            result = me.editCell(cell, true, e);
            if(result === false)
                return false;
            return;
        },


        _editable: function () {
            var me = this,
                editable = me.options.editable,
                needsClickHandler = false;

            Grid.fn._editable.call(me);

            // for some columns editing is done via intercepting the click event
            // radiogroup: need to get value of clicked item and post directly to data row, there's no editor
            $.each(me.columns, function (idx, col) {
                if (col.type == 'radiogroup') {             
                    needsClickHandler = true;
                    return false;
                }
            });

            if (editable && needsClickHandler) {
                var mode = me._editMode();
                if (mode === "incell") {
                    if (editable.update !== false) {
                        TS.log('subscribing to click event of ' + me.wrapper.attr('id'));
                        me.wrapper.on(CLICK + NS, "tr:not(.k-grouping-row) > td > div.radio-cell", $.proxy(me._onRadioCellClicked, me));
                    }
                }
            }
        },

        _buildEventArgs: function (rowIdx, model, oldValue, newValue, column) {
            var e;

            e = {
                rowIdx: rowIdx,
                record: model,
                oldValue: oldValue,
                newValue: newValue,
                fieldName: column.fieldCfg.PropertyName(),
                displayField: ko.valueOf(column.fieldCfg.DisplayPropertyName),
                columnType: column.type
            };

            return e;
        },

        editCell: function (cell, autoFocus, args) {
            cell = $(cell);

            var me = this,
                blp = me._bindingListProperty,
                column, listField,
                model,
                cfg, dynCfg,
                editor, widget, tr, cachedTr,
                editorType,
                e, uid, rowIdx,
                canEdit = true;

            if (unwrap(blp.AllowEdit) === false) {
                canEdit = false;
            }

            me._tooltip && me._tooltip.destroy();
            column = me.columns[me.cellIndex(cell)];
            model = me._modelForContainer(cell);
            editorType = column.type;
            listField = blp.getFieldByName(column.fieldCfg.Name);
            if (!model || column.editable === false || (listField !== null && listField.ReadOnly === true)) {
                canEdit = false;
            }

            if (editorType == 'dynamic') {
                dynCfg = TS.widget.gridHelper.getCfg(column.fieldCfg, model);
                editorType = dynCfg.type;
            }

            if (!canEdit) {
                if (editorType == 'textarea') {
                    var ttText = unwrap(model[column.field]);
                    if (ttText) {
                        me._tooltip = _showTooltip(cell, ttText);
                    }
                }
                return;
            }

            // prepare argument for events
            uid = me._uidForContainer(cell);
            rowIdx = me.dataSource.indexFor(uid);

            e = me._buildEventArgs(rowIdx, model, null, null, column);
            blp._onCellBeginEdit(e);

            // editing has been cancelled by event handler
            if (e.isDefaultPrevented && e.isDefaultPrevented()) {
                return false;
            }

            me._observeRecord(model, column, rowIdx);

            if (editorType == 'bool') {
                (autoFocus !== true) && _handleCheckEdit(me, model, column, cell);
            } else if (editorType == 'radiogroup') {
                _handleRadioCell(me, model, column, cell, args)
            }
            else if (uneditableColumns.indexOf(editorType) > -1) {
                return;
            }
            else {
                me._editContainer = cell;
                cell.addClass("k-edit-cell")
                    .parent().addClass("k-grid-edit-row");

                cfg = {
                    field: column.field,
                    type: editorType
                };
                $.extend(cfg, column.fieldCfg);

                cell.kendoKoEditable({
                    cfg: cfg,
                    model: model,
                    parentViewModel: blp && blp._getOwner()
                });

                editor = cell.data("kendoKoEditable");
                editor.bind('escapePressed', function () {
                    if (me.editable) {
                        me.editable.end();
                    }
                    me.closeCell();
                });
                editor.bind('enterPressed', function () {
                    if (me.editable) {
                        me.editable.end();
                    }
                    me.closeCell();
                });

                //                editor.bind('endEdit', function() {
                //                    blp._onCellEndEdit(e);
                //                });

                // for lookup columns maintain a transport cache - otherwise data will be downloaded for each cell
                if (column.type == 'adaptiveLookup') {
                    cachedTr = me._transports[column.field];
                    widget = editor.getWidget();
                    if (widget) {
                        tr = widget.dataSource.transport;
                        if (cachedTr && !tr.options.cacheCleared) {
                            tr.copyCache(cachedTr);
                        } else {
                            me._transports[column.field] = tr;
                        }
                    }
                }

                me.editable = editor;
                editor._widget && typeof editor._widget.focus === 'function' && editor._widget.focus();
                column.autoOpen && editor._widget && editor._widget.options.name === "TsLateFetchCombo" && typeof editor._widget.open === 'function' && editor._widget.open();
            }

            me.trigger('edit', {container: cell, model: model});
        },

        closeCell: function (e) {
            var me = this;

            Grid.fn.closeCell.call(me);
            me._tooltip && me._tooltip.destroy();
        },

        _destroyEditable: function () {
            var me = this,
                ed = me.editable;

            if (ed) {
                ed.end();
                ed._destroyEditor();
            }

            Grid.fn._destroyEditable.call(me);
        },

        _displayCell: function (cell, column, dataItem) {
            var that = this,
                state = {storage: {}, count: 0},
                settings = $.extend({}, kendo.Template, that.options.templateSettings),
                tmpl = kendo.template(that._cellTmpl(column, state), settings),
                plain;

            if (state.count > 0) {
                tmpl = $.proxy(tmpl, state.storage);
            }

            plain = ko.toJS(dataItem);

            cell.empty().html(tmpl(plain));
        },

        /**
         * Refreshes current row.
         * Needed for cases where there is an event on a cell value changed that triggers a change in other cells in the same row.
         * @param {object|array} exceptColumns - A column or an array of columns for which to avoid refresh
         */
        _refreshCurrentRow: function (exceptColumns) {
            var me = this,
                row = me.select();
            // exit if selection is not available (hideSelection blp option unselects rows before refresh)
            if (!row || !row.length)
                return;

            var dataItem = me.dataItem(row),
                cells = $(row).children('td[role="gridcell"]'),
                i,
                cell,
                column;
            if (exceptColumns && !exceptColumns.length)
                exceptColumns = [exceptColumns];

            for (i = 0; i < me.columns.length; i++) {
                column = me.columns[i];
                if (exceptColumns && exceptColumns.indexOf(column) > -1)
                    continue;
                cell = cells.eq(i);
                me._displayCell(cell, column, dataItem);
            }
        },

        // Fix for adjusting locked content height when a parent container (other than wrapper) changes visibility from hidden to visible.
        _setContentHeight: function (once) {
            Grid.fn._setContentHeight.call(this);
            if (this.content && this.lockedContent) {
                var height = this.content.height(),
                    lockedContent = this.lockedContent.height(),
                    scrollbar = kendo.support.scrollbar();
                if (height > scrollbar * 2) {
                    scrollbar = this.table[0].offsetWidth > this.table.parent()[0].clientWidth ? scrollbar : 0;
                    if (height - scrollbar !== lockedContent) {
                        this.lockedContent.height(height - scrollbar);
                        this._syncLockedContentHeight();
                        this._syncLockedHeaderHeight();
                        if (!once && !this.options.height) {
                            //try again, if the height is variable, when a hidden grid becomes visible for the first time
                            //the content height is not correct, it is slightly smaller.
                            this._setContentHeight(true);
                        }
                    }
                }
            }
        },

        deselect: function (el) {
            var that = this,
                selectable = that.selectable;
            return selectable.deselect(el);
        },

        _templates: function () {
            var me = this;

            Grid.fn._templates.call(me);

            if (!me._alternateRowStyle) {
                me.altRowTemplate = me.rowTemplate;
                me.lockedAltRowTemplate = me.lockedRowTemplate;
            }
        },

        //fix for scrolling over locked columns
        _wheelScroll: function (e) {
            if (!this.options.scrollable.virtual) {
                var content = this.content,
                    scrollHeight = content[0].scrollHeight,
                    delta = kendo.wheelDeltaY(e);
                if (
                    //the grid is not scrollable
                (scrollHeight <= content.height()) ||
                    //the scroll riched to the bottom
                (delta < 0 && (content.scrollTop() + content.innerHeight() >= scrollHeight)) ||
                    //the scroll riched to the top
                (delta > 0 && content.scrollTop() === 0)
                ) {
                    return;
                }
            }

            Grid.fn._wheelScroll.call(this, e);
        },

        //navigate between editable cells
        _navigatable: function () {
            var me = this,
                table = me.table.add(me.lockedTable),
                headerTable = me.thead.parent().add($(">table", me.lockedHeader)),
                dataTable = table;

            if (!me.options.navigatable) {
                return;
            }

            if (me.options.scrollable) {
                dataTable = table.add(headerTable);
            }

            table.off("keydown" + NS);

            table.on("keydown" + NS, function (e) {
                var key = e.keyCode,
                    handled = false,
                    currentProxy = $.proxy(me.current, me),
                    activeElement = kendo._activeElement,

                    isInCell = me._editMode() == "incell",
                    shiftKey = e.shiftKey,
                    relatedRow = $.proxy(me._relatedRow, me);

                if (kendo.keys.TAB == key && me.options.editable && isInCell) {

                    var nextEditable = function () {
                        var current = currentProxy(),
                            cell = $(activeElement()).closest(".k-edit-cell");
                        current = $(current);
                        if (cell[0] && cell[0] !== current[0]) {
                            current = cell;
                        }
                        cell = me._tabNext(current, e.currentTarget, table, relatedRow, shiftKey);

                        if (!current.is("th") && cell.length) {
                            me._handleEditing(current, cell, cell.closest(table));
                            if (!me.editable) {
                                _toggleCheckEditClass(me, current, false);
                                return nextEditable();
                            }
                            handled = true;

                            me._prevSelection = cell.parent().attr('data-uid');
                            me.clearSelection()
                            me._doRestoreSelection();
                        }

                        _toggleCheckEditClass(me, current, false);
                    }

                    nextEditable();
                }

                if (kendo.keys.SPACEBAR == key && me.options.editable && isInCell) {
                    var current = currentProxy();
                    var model = me._modelForContainer(current);
                    var column = me.columns[me.cellIndex(current)];

                    if (column.type == 'bool') {
                        _handleCheckEdit(me, model, column, current);
                        handled = true;
                    }
                }

                if (handled) {
                    //stop handling tab key
                    e.isImmediatePropagationStopped = function () {
                        return true;
                    };
                    //prevent browser scrolling
                    e.preventDefault();
                    //required in hierarchy
                    e.stopPropagation();
                }
            });

            // Kendo executes prevent default on header cells which doesn't allow text selection
            // Temporarily override the jquery event func preventDefault to avoid preventing the event
            var eventName = (kendo.support.touch ? "touchstart" + NS : "mousedown" + NS),
                eventTarget = NAVROW + ">" + NAVCELL,
                preventDefault;

            dataTable
                .on(eventName, eventTarget, function (e) {
                    var currentTarget = $(e.currentTarget),
                        isHeader = currentTarget.is("th");

                    if (isHeader) {
                        preventDefault = e.preventDefault;
                        e.preventDefault = $.noop;
                    }
                });

            Grid.fn._navigatable.call(me);

            dataTable
                .on(eventName, eventTarget, function (e) {
                    var currentTarget = $(e.currentTarget),
                        isHeader = currentTarget.is("th");

                    if (isHeader) {
                        e.preventDefault = preventDefault || e.preventDefault;
                        preventDefault = null;
                    }
                });
        },

        //copied entirely from kendo grid tabNext
        _tabNext: function (current, currentTable, dataTable, relatedRow, back) {
            var isLocked = dataTable.length == 2;
            var switchRow = true;
            var next = back ? current.prevAll(DATA_CELL + ":first") : current.nextAll(":visible:first");

            if (!next.length) {
                next = current.parent();
                if (isLocked) {
                    switchRow = (back && currentTable == dataTable[0]) || (!back && currentTable == dataTable[1]);
                    next = relatedRow(next);
                }

                if (switchRow) {
                    next = next[back ? "prevAll" : "nextAll"]("tr:not(.k-grouping-row):not(.k-detail-row):visible:first");
                }
                next = next.children(DATA_CELL + (back ? ":last" : ":first"));
            }

            return next;
        }

    });

    ui.plugin(TsKendoGrid);

    ko.bindingHandlers['kendoTsGrid'] = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var config = valueAccessor(),
                ds,
                $element = $(element),
                readOnly = TS.ifNotDefined(config.readOnly, false),
                allowEdit = TS.ifNotDefined(config.allowEdit, true),
                editable = readOnly !== true && allowEdit !== false,
                selectionmode = 'row';

            ds = TS.Util.getProperty(bindingContext.$data, config.dataSource);
            if (!ds) {
                TS.Log.error("Error: Invalid data source " + config.dataSource + " for grid " + $element.attr('id'));
                return;
            }

            var options = {
                dataSource: ds,
                columnAutoWidth: config.columnAutoWidth !== false,
                autoFocus: config.autoFocus || false,
                selectable: selectionmode,
                editable: editable,
                readOnly: readOnly,
                allowAdd: TS.ifNotDefined(config.allowAdd, true),
                showColumnHeaders: TS.ifNotDefined(config.showColumnHeaders, true),
                allowEdit: allowEdit,
                allowDelete: TS.ifNotDefined(config.allowDelete, true),
                resizable: true,
                navigatable: true,
                sortable: {
                    mode: "multiple",
                    allowUnsort: true
                }
            };
            config.height && (options.height = config.height);

            $element.kendoTsKendoGrid(options);
        }
    };


})(jQuery);